// extracted by mini-css-extract-plugin
export default {"ButtonWrapper":"button_ButtonWrapper__+zbj+","Alt":"button_Alt__Sv7mc","Block":"button_Block__wu83F","HideOutline":"button_HideOutline__0PLkx","Simple":"button_Simple__0VyAx"};